import { Routes, Route, useLocation } from "react-router-dom";

import IndexPage from "../../pages/StampsIndexPage/StampsIndexPage";
import ErrorPage from "../../pages/ErrorPage/ErrorPage";
import AuthPage from "../../pages/AuthPage/AuthPage";
import StampsNewPage from "../../pages/StampsNewPage/StampsNewPage";
import StampsShowPage from "../../pages/StampsShowPage/StampsShowPage";
import StampsEditPage from "../../pages/StampsEditPage/StampsEditPage";
import AdminPage from "../../pages/AdminPage/AdminPage";
import HiddenStampsPage from "../../pages/HiddenStampsPage/HiddenStampsPage";
export default function Main({ user, setUser }) {
  const location = useLocation();
  const isStampShow =
    /^\/stamps\/[^/]+$/.test(location.pathname) &&
    !location.pathname.endsWith("/edit") &&
    !location.pathname.endsWith("/new");

  return (
    <main
      className={`min-h-[calc(100vh-50px)] mx-auto ${isStampShow ? "bg-neutral-950" : ""}`}
    >
      <Routes>
        <Route path="/" element={<IndexPage user={user} />} />
        <Route path="/login" element={<AuthPage user={user} setUser={setUser} />} />
        <Route path="/stamps/new" element={<StampsNewPage user={user} />} />
        <Route
          path="/stamps/:catalogue_id/edit"
          element={<StampsEditPage user={user} />}
        />
        <Route
          path="/stamps/:catalogue_id"
          element={<StampsShowPage user={user} />}
        />
        <Route path="/admin" element={<AdminPage user={user} />} />
        <Route path="/hidden" element={<HiddenStampsPage user={user} />} />
        <Route path="/*" element={<ErrorPage />} />
      </Routes>
    </main>
  );
}
